import { useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Form } from 'react-bootstrap';
import { toast } from 'react-toastify';
import Loader from '../components/Loader';
import { useResetPasswordMutation } from '../slices/usersApiSlice';

const ResetPasswordScreen = () => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [resetPassword, { isLoading }] = useResetPasswordMutation();
  const navigate = useNavigate();
  const { token } = useParams();

  const submitHandler = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      toast.error('Passwords do not match');
      return;
    }

    try {
      const res = await resetPassword({ token, password }).unwrap();
      toast.success(res.message);
      navigate('/login');
    } catch (err) {
      toast.error(err?.data?.message || err.error);
    }
  };

  return (
    <div className="section-modern">
      <div className="container-modern">
        <div className="row justify-content-center">
          <div className="col-md-6 col-lg-5">
            <div className="form-modern fade-in">
              <div className="text-center mb-4">
                <h1 className="text-primary mb-2">Reset Password</h1>
                <p className="text-secondary">
                  Choose a new password for your League Runner account.
                </p>
              </div>

              <Form onSubmit={submitHandler}>
                <div className="form-group-modern">
                  <label htmlFor="password" className="form-label-modern">
                    New Password
                  </label>
                  <input
                    type="password"
                    id="password"
                    className="form-input-modern"
                    placeholder="Enter a new password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    minLength={6}
                    required
                  />
                </div>

                <div className="form-group-modern">
                  <label htmlFor="confirmPassword" className="form-label-modern">
                    Confirm Password
                  </label>
                  <input
                    type="password"
                    id="confirmPassword"
                    className="form-input-modern"
                    placeholder="Confirm your new password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    minLength={6}
                    required
                  />
                </div>

                <button
                  disabled={isLoading}
                  type="submit"
                  className="btn btn-primary-modern w-100 mb-3"
                >
                  {isLoading ? 'Resetting Password...' : 'Reset Password'}
                </button>
              </Form>

              {isLoading && (
                <div className="text-center py-3">
                  <Loader />
                </div>
              )}

              <div
                className="text-center mt-4 pt-4"
                style={{ borderTop: '1px solid var(--border-light)' }}
              >
                <p className="text-secondary mb-0">
                  Need to try again later?{' '}
                  <Link to="/forgot-password" className="text-decoration-none fw-medium">
                    Request another reset link
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordScreen;
